const isTruthyFlag = (value: string | undefined): boolean => {
  if (!value) {
    return false;
  }

  return value.toLowerCase() === "true" || value === "1";
};

export const isLearningDemoMode = (): boolean => {
  return (
    import.meta.env.MODE === "demo" &&
    isTruthyFlag(import.meta.env.VITE_LEARNING_DEMO_MODE)
  );
};
